import showJSDConfirmPayDialog from '@/components/jsdConfirm/jsdConfirmPayDialog';
import { waitOrderDetect, WaitOrderSense } from '@/utils/waitOrderDetect';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import Switch from 'react-switch';
import './index.scss';
import {
  apiEquityPackPay,
  apiEquityPackPreOrder,
  apiGetBalance,
  apiGetDirectRechargeList,
  apiGetPayTypeConfigList,
  apiGetSecondActivityList,
  apiGetUserInfo,
  apiGetWeChatSignature,
} from '../../api';
import AppBar from '../../components/appBar';
import Button from '../../components/button';
import CalcCount from '../../components/calcCount';
import Page from '../../components/page';
import RadioBox from '../../components/radioBox';
import main from '../../main';
import { DefaultPayType, PayType } from '../../utils/dict';
import showPayPage from '../../utils/pay';
import { formatNumber, LoadingMask, modelParsePrice, showConfirm, showToast } from '../../utils/utils';
import OrderAgreement from '@/components/orderAgreement';

interface OrderInfo {
  cardPackDetailId: string;
  couponPrice: number;
  emId: string;
  endEffectTime: string;
  isUnion: boolean;
  name: string;
  orderPrice: number;
  packDetailContent: string;
  realPrice: number;
  salePrice: number;
  startEffectTime: string;
  singleSalePrice: string;
  cardProductActivityEquityPackJson?: {
    img: string;
    price: number;
    tips: string;
  };
  packPeriodTotalNum: number;
  activityCardPackDetail?: {
    salePrice: number;
    activityNumber: number;
    name: string;
  };
}

export default function EquityOrderConfirmPage() {
  const navigate = useNavigate();
  const payTypeRef = useRef<HTMLDivElement>(null);
  const [wxReady, setWxReady] = useState(false);
  // 订单数量
  const [count, setCount] = useState(1);
  // 上个页面已选套餐和（本月或下月）
  const { emPack: _emPack }: { emPack: CardProductAd } = useLocation().state ?? {};
  const [emPack, setEmPack] = useState(_emPack);
  // 是否需要高亮闪烁
  const [selectPayType, setSelectPayType] = useState<boolean>();
  // 预存列表 如果没有预存会返回首充列表
  const [preMoneyList, setPreMoneyList] = useState<Premoney[]>([]);
  // 已选预存
  const [preMoney, setPreMoney] = useState<Premoney>();
  // 预存列表是否已加载完成
  const [preMoneyListLoaded, setPreMoneyListLoaded] = useState(false);
  const [defaultPayType, setDefaultPayType] = useState(DefaultPayType.all);
  // 设备余额
  const [balance, setBalance] = useState(modelParsePrice(main.currentEm?.cardDetailWalletVo?.availableAmount || 0));
  // 是否有操作密码
  // const [ifPwd, setIfPwd] = useState(false);
  // 余额和操作密码是否加载完成
  const [balanceLoaded, setBalanceLoaded] = useState(false);
  // 充值优惠信息
  // const [payReduction, setPayReduction] = useState<PayReduction>({});
  // 计算后得到的是否余额支付可用
  const [canBalancePay, setCanBalancePay] = useState(false);
  // 支付方式列表
  const [payConfigList, setPayConfigList] = useState<PayTypeConfig[]>([]);
  const [rechargePackageList, setRechargePackageList] = useState<any[]>([]);
  // 支付方式列表是否加载完成
  const [payConfigListLoaded, setPayConfigListLoaded] = useState(false);
  // 已选支付方式
  const [payType, setPayType] = useState<string>(PayType.balance);
  // 使用组合支付
  const [isUnion, setIsUnion] = useState(false);
  // 选择权益包
  const [selectEquity, setSelectEquity] = useState(false);
  // 订单信息
  const [orderInfo, setOrderInfo] = useState<OrderInfo>();
  const [submitFlag, setsubmitFlag] = useState<boolean>(false);
  const [agreementAgreed, setAgreementAgreed] = useState<boolean>(true);
  // 停留或后退计时
  const backRef = useRef<{ timer?: NodeJS.Timeout; time: number; isShow: boolean }>({ time: 0, isShow: false });
  useEffect(() => {
    preLoad();
    let _backRef = backRef.current;
    // @ts-ignore
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', () => setWxReady(true), false);
        // @ts-ignore
      } else if (document.attachEvent) {
        // @ts-ignore
        document.attachEvent('WeixinJSBridgeReady', () => setWxReady(true));
      }
    } else {
      setWxReady(true);
    }
    wxConfig();
    startBackTimer();
    return () => {
      if (_backRef.timer) {
        clearInterval(_backRef.timer);
      }
    };
  }, []); // eslint-disable-line

  function startBackTimer() {
    if (!backRef.current.timer) {
      backRef.current.timer = setInterval(() => {
        backRef.current.time++;

        if (backRef.current.time >= 60) {
          backRef.current.isShow = true;
          handleLongTimeDialog();
        }
        if (backRef.current.isShow) {
          clearInterval(backRef.current.timer);
        }
      }, 1000);
    }
  }

  async function handleBack() {
    if (backRef.current.isShow) {
      navigate(-1);
    } else {
      let res = await showConfirm({
        title: '提示',
        content: '您是否存在疑问，需要联系客服？',
        cancelBtnText: '返回',
        confirmBtnText: '联系客服',
      });
      if (res === 1) {
        navigate('/customer');
      } else {
        navigate(-1);
      }
    }
  }

  async function handleLongTimeDialog() {
    let res = await showConfirm({
      title: '提示',
      content: '您在该界面停留时间过久，是否存在疑问？',
      hideCancelBtn: true,
      confirmBtnText: '联系客服',
    });
    if (res === 1) {
      navigate('/customer');
    }
  }

  useEffect(() => {
    if (balanceLoaded) {
      preOrder();
    }
  }, [balanceLoaded, count]); // eslint-disable-line
  /**
   *  预加载
   */
  async function preLoad() {
    if (!emPack || !main.currentEm?.id) {
      navigate('/home', { replace: true });
      return;
    }
    setEmPack(emPack);
    LoadingMask.show('正在处理...');
    await loadPreMoney();
    await loadBalance();
    // await loadPayConfigReduction();
    await getRechargePackageList();
    LoadingMask.hide();
  }
  async function getRechargePackageList() {
    try {
      let res = await apiGetDirectRechargeList(main.currentEm!.id!);

      let data = res.data;
      if (data.code === 200) {
        let list = (data?.data ?? []).filter((item: any) => item?.showRechargeStatus === 'show');
        // const arr =
        //   list?.filter((item: any) => {
        //     let giveAmount =
        //       Number(item.price ?? 0) >= Number(item.amount ?? 0)
        //         ? Number(item.activityAmount ?? 0) + Number(item.price ?? 0) - Number(item.amount ?? 0)
        //         : 0;
        //     return giveAmount > 0;
        //   }) ?? [];
        const grouped = list?.reduce((acc: any, _: any, i: any, source: any) => {
          if (i % 3 === 0) {
            acc.push(source.slice(i, i + 3));
          }
          return acc;
        }, []);
        setRechargePackageList(grouped ?? []);
      } else {
      }
    } catch (e) {}
  }
  /**
   *  获取预存金额
   */
  async function loadPreMoney() {
    let _list: Premoney[] = [];

    try {
      let res = await apiGetSecondActivityList(main.currentEm?.id!, emPack!.id!);
      let data = res.data;
      if (data.code === 200) {
        setPreMoneyListLoaded(true);
        if (data.data) {
          data.data.forEach((i: any) => {
            _list.push({
              id: i.id,
              amount: parseFloat(i.amount ?? 0),
              payAmount: parseFloat(i.payAmount ?? 0),
              price: parseFloat(i.price ?? 0),
              forceActivity: i.forceActivity === 'Y',
              activityAmount: parseFloat(i.activityAmount ?? 0),
            });
          });
        }
      } else {
        setPreMoneyListLoaded(false);
      }
    } catch (e: any) {
      showToast(e.message || '获取订单信息错误');

      setPreMoneyListLoaded(false);
    }
    setPreMoneyList(_list);
  }
  /**
   * 获取余额
   */
  async function loadBalance() {
    try {
      var res = await apiGetBalance(main.currentEm?.id!);
      var data = res.data;
      if (data.code === 200) {
        await loadPayConfigList(data?.data?.payType);
        // var _data = data['data'];
        let balance = modelParsePrice(data.data.availableAmount);
        // let ifPwd = _data['isPayPassword'] === true;
        setBalance(balance);
        // setIfPwd(ifPwd);
        setBalanceLoaded(true);
        setDefaultPayType(data.data.payType || DefaultPayType.all);
        // if (data.data.payType === DefaultPayType.userSelected) {
        //   setPayType(PayType.userSelected);
        // } else if (data.data.payType && data.data.payType !== 'all') {
        //   if (data.data.payType === DefaultPayType.balance) {
        //     setPayType(PayType.balance);
        //   } else if (data.data.payType === DefaultPayType.wechat) {
        //     setPayType(PayType.wechatJsPay);
        //   } else if (data.data.payType === DefaultPayType.jsd_mini_wx) {
        //     setPayType(PayType.jsd_mini_wx);
        //   }
        // }
      } else {
        setBalanceLoaded(false);
      }
    } catch (e) {
      setBalanceLoaded(false);
    }
  }

  /**
   * 获取支付配置列表
   */
  async function loadPayConfigList(_payType: string) {
    try {
      let res = await apiGetPayTypeConfigList();
      let data = res.data;
      if (data.code === 200) {
        let list: PayTypeConfig[] = data.data ?? [];
        setPayConfigList(list);
        setPayConfigListLoaded(true);
        if (_payType === PayType.userSelected) {
          setPayType(PayType.userSelected);
        } else {
          let defaultSelectedItem = (list ?? []).filter((i: PayTypeConfig) => i?.defaultSelected === 'Y');
          setPayType(!!defaultSelectedItem ? defaultSelectedItem[0]?.payType! : '');
        }
        // let payTypes = list.map((i: PayTypeConfig) => i.payType!);
        // if (payType !== PayType.userSelected && payTypes.length && !payTypes.includes(payType)) {
        //   setPayType(payTypes[0]);
        // }
      }
    } catch (e) {}
  }

  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;

    let res = await apiGetWeChatSignature(
      main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
      main.appId
    );
    let data = res.data;
    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'],
      });
    }
  }
  /**
   *  预下单
   *
   */
  async function preOrder() {
    LoadingMask.show('正在生成预览...');
    try {
      var res = await apiEquityPackPreOrder(emPack.equityPackageInfoIds!, main.currentEm!.id!, count);
      let data = res.data;
      if (data.code !== 200) {
        return showToast(data.msg || '接口错误');
      }
      let _orderInfo: OrderInfo = data.data;
      _orderInfo.salePrice = modelParsePrice(_orderInfo.salePrice);
      _orderInfo.orderPrice = modelParsePrice(_orderInfo.orderPrice);
      _orderInfo.realPrice = modelParsePrice(_orderInfo.realPrice);
      _orderInfo.couponPrice = modelParsePrice(_orderInfo.couponPrice);
      let _canBalancePay = balance >= (_orderInfo.orderPrice ?? 0);
      if (!!_orderInfo.cardProductActivityEquityPackJson) {
        _orderInfo.cardProductActivityEquityPackJson!.price = modelParsePrice(
          _orderInfo.cardProductActivityEquityPackJson!.price
        );
        setSelectEquity(true);
        _canBalancePay =
          balance >= (_orderInfo.realPrice ?? 0) + (_orderInfo.cardProductActivityEquityPackJson!.price ?? 0);
      }
      if (!!_orderInfo.activityCardPackDetail) {
        _orderInfo.activityCardPackDetail!.salePrice = modelParsePrice(_orderInfo.activityCardPackDetail!.salePrice);
        _orderInfo.activityCardPackDetail!.activityNumber = modelParsePrice(
          _orderInfo.activityCardPackDetail!.activityNumber
        );
      }

      let _payType = payType;
      let _preMoney: Premoney | undefined = undefined;

      let forceActivity = preMoneyList.some((i) => i.forceActivity === true);
      if (!_canBalancePay && _payType === PayType.balance) {
        _payType = payConfigList.find((i) => i.payType !== PayType.balance)?.payType!;
        if (preMoneyList?.length && forceActivity) {
          _preMoney = preMoneyList[0];
        }
      }

      if (preMoneyList?.length && (_preMoney?.payAmount ?? 0) < (_orderInfo.orderPrice ?? 0)) {
        for (let i of preMoneyList) {
          if (i.payAmount >= (_orderInfo.orderPrice ?? 0)) {
            _preMoney = i;
            break;
          }
        }
      }
      if ((_preMoney?.payAmount ?? 0) < (_orderInfo.orderPrice ?? 0)) {
        _preMoney = undefined;
      }
      if (!preMoney && !forceActivity) {
        _preMoney = undefined;
      }
      if (!!preMoneyList.length && _payType !== PayType.balance && selectEquity) {
        _preMoney = getRealPayItem();
      }

      setOrderInfo(_orderInfo);
      setCanBalancePay(_canBalancePay);
      if (defaultPayType === DefaultPayType.all) {
        setPayType(_payType);
      }
      setPreMoney(_preMoney);
    } catch (e) {
      console.log(e);
    } finally {
      LoadingMask.hide();
    }
  }
  /**
   * 权益包+套餐金额 → 返回匹配的 强充套餐对象
   * 规则：
   * 1. 小于所有档位 → 返回最小档位
   * 2. 大于等于最大档位 → 返回最大档位
   * 3. 中间 → 返回第一个 >= 总金额的档位
   */
  const getRealPayItem = () => {
    const equityPrice = Number(orderInfo?.cardProductActivityEquityPackJson?.price || 0);
    const orderPrice = Number(orderInfo?.orderPrice || 0);
    // 总金额：套餐 + 权益包
    const payAmount = equityPrice + orderPrice;

    if (!preMoneyList || preMoneyList.length === 0) {
      return undefined;
    }

    const sortedList = [...preMoneyList].sort((a, b) => Number(a.payAmount) - Number(b.payAmount));

    const minItem = sortedList[0];
    const maxItem = sortedList[sortedList.length - 1];
    const minAmount = Number(minItem.payAmount);
    const maxAmount = Number(maxItem.payAmount);

    if (payAmount < minAmount) {
      // 小于最小值
      return minItem;
    } else if (payAmount >= maxAmount) {
      // 大于等于最大值
      return undefined;
    } else {
      // 中间
      return sortedList.find((item) => Number(item.payAmount) >= payAmount);
    }
  };

  async function handlePay() {
    if (submitFlag) return;
    // 先判断是否未选择支付方式（userSelected），触发闪烁提示
    if (payType === PayType.userSelected) {
      setSelectPayType(false);
      showToast('请选择支付方式后进行支付~');
      payTypeRef.current?.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'center', // 滚动到中间位置
      });
      // 先移除再添加，确保CSS动画能重新开始
      requestAnimationFrame(() => {
        setSelectPayType(true);
        setTimeout(() => setSelectPayType(false), 3000);
      });
      return;
    }
    let _payList = (payConfigList ?? []).map((item) => item.payType);
    if (!_payList.includes(payType)) {
      setSelectPayType(false);
      showToast('请选择支付方式后进行支付~');
      payTypeRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      requestAnimationFrame(() => {
        setSelectPayType(true);
        setTimeout(() => setSelectPayType(false), 3000);
      });
      return;
    }
    setsubmitFlag(true);
    // 判断是否有待支付订单，如果有就关闭订单
    const isPass = await waitOrderDetect({ sense: WaitOrderSense.Pay });
    if (!isPass) return;

    if (!main.openId && !main.isDev) {
      return showToast('授权失败,请在微信内打开');
    }
    if (!balanceLoaded || !preMoneyListLoaded || !payConfigListLoaded) {
      return showToast('获取下单数据错误，请稍后重试');
    }
    if (!canBalancePay && payType === PayType.balance) {
      navigate('/recharge');
      return;
    }

    // 要支付的金额
    let price = (payType === PayType.balance ? orderInfo?.realPrice : preMoney?.payAmount ?? orderInfo?.realPrice) ?? 0;
    if (selectEquity) {
      // price = price + orderInfo!.cardProductActivityEquityPackJson!.price;
      let _price = (price = price + orderInfo!.cardProductActivityEquityPackJson!.price);
      if (!!preMoneyList.length && payType !== PayType.balance) {
        price = getRealPayAmount();
      } else {
        price = _price;
      }
    }
    let confirmRes = await showConfirm({
      title: '提示',
      content: (
        <div className="d-flex-c ai-start font-size-12">
          <div>
            本次消费用<span className="text-color-p">{PayType.typeStr(payType)}</span>支付:{price}元
          </div>
          {!!selectEquity && (
            <div>
              <span className="text-color-9">权益费:</span>
              <span className="text-color-3">{orderInfo!.cardProductActivityEquityPackJson!.price}元</span>
            </div>
          )}
          <div className="text-left">
            <span className="text-color-9">订单名称:</span>
            <span className="text-color-3">{orderInfo?.name}</span>
          </div>
          <div>
            <span className="text-color-9">订单类型:</span>
            <span className="text-color-3">权益包</span>
          </div>
          <div>
            <span className="text-color-9">套餐消费:</span>
            <span className="text-color-3">{orderInfo?.realPrice}元</span>
          </div>
          <div>套餐有效期:</div>
          <div className={`text-color-3`}>
            {dayjs(orderInfo?.startEffectTime).format('YYYY-MM-DD')}至
            {dayjs(orderInfo?.endEffectTime).format('YYYY-MM-DD')}
          </div>
        </div>
      ),
    });
    if (!confirmRes) {
      setsubmitFlag(false);
      return;
    }

    try {
      LoadingMask.show('正在提交...');

      var body: any = {
        emId: main.currentEm?.id,
        // cardPackDetailId: emPack!.id!,
        // cardProductActivityDetailId: emPack!.jumpValue,
        equityPackageInfoIds: emPack.equityPackageInfoIds!,
        payType: price > 0 ? payType : PayType.balance,
        openId: main.openId,
        appId: main.appId,
        number: count,
        isUnion,
        isEquity: selectEquity,
      };
      if (payType === PayType.balance) {
        // body.payPassword = pwd;
      } else {
        body.cardPayDetailId = preMoney?.id;
      }

      let res = await apiEquityPackPay(body);
      let data = res.data;
      if (data.code === 200) {
        if (payType === PayType.balance || price === 0) {
          paySuccess();
        } else if (
          payType === PayType.aliPage ||
          payType === PayType.jsd_h5_ali ||
          payType === PayType.lkl_ali_pay ||
          payType === PayType.yh_wx_web ||
          payType === PayType.yh_ali_web
        ) {
          //支付宝支付
          let _data = data.data;
          let payRes = await showPayPage(_data, payType);

          if (payRes.code === 300) {
            if (payRes.url) {
              LoadingMask.hide();
              window.location.href = payRes.url;
              // await showConfirm({
              //   title: '提示',
              //   content: '是否支付完成?',
              //   confirmBtnText: '支付完成',
              //   cancelBtnText: '未完成',
              // });
              navigate('/home', { replace: true });
            }
            showToast(payRes.msg);
          } else if (payRes.code === 500) {
            showToast(payRes.msg);
          } else {
            showToast('数据还在准备,请稍后重试');
          }
        } else if (payType === PayType.jsd_mini_wx) {
          // 金舜达 银盛支付 小程序支付  需要弹窗让用户再次点击按钮
          LoadingMask.hide();
          let res = await showJSDConfirmPayDialog({
            miniOrgId: data.data.miniOrgId,
            miniPath: data.data.miniPath,
            miliPaLink: data.data.miniPayLink,
          });
          if (res === 2) {
            showToast('小程序跳转失败');
          } else if (res === 1) {
            let payRes = await showConfirm({
              title: '提示',
              content: '是否支付完成?',
              confirmBtnText: '支付完成',
              cancelBtnText: '未完成',
            });
            if (!payRes) return;
            navigate('/home', { replace: true });
          } else {
            showToast('取消支付');
          }
        } else {
          if (wxReady) {
            let _data = data.data;
            let payRes = await showPayPage(_data, payType);

            if (payRes.code === 200) {
              paySuccess();
            } else if (payRes.code === 300) {
              if (payRes.url) {
                LoadingMask.hide();
                navigate('/customer', { state: { url: payRes.url, title: '银联支付', pay: true } });
              }
              showToast(payRes.msg);
            } else if (payRes.code === 500) {
              showToast(payRes.msg);
            }
          } else {
            showToast('数据还在准备,请稍后重试');
          }
        }
      } else {
        showToast(data.msg ?? '下单失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '下单失败');
    } finally {
      setsubmitFlag(false);
      LoadingMask.hide();
    }
  }

  async function paySuccess() {
    try {
      let res = await apiGetUserInfo(main.loginKey!);
      let data = res.data;

      if (data.code === 200) {
        main.user = data.data.user;
      }
    } catch (e: any) {
      console.error(e);
    } finally {
      navigate('/recharge-success', {
        replace: true,
        state: {
          name: orderInfo?.name,
          type: '权益包',
          startTime: dayjs(orderInfo?.startEffectTime).format('YYYY-MM-DD'),
          endTime: dayjs(orderInfo?.endEffectTime).format('YYYY-MM-DD'),
        },
      });
    }
  }

  /**
   * 已选套餐包
   * @returns view
   */
  function renderSelectPack() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20 d-flex-r ai-center">
        <div className="flex-1">
          <div>订单名称：{orderInfo?.name}</div>
          <div className="mt-10">订单类型：权益包</div>
        </div>
        <div className="font-size-18 font-widget-600">￥{orderInfo?.realPrice}</div>
      </div>
    );
  }

  /**
   * 购买数量
   * @returns view
   */
  function renderCount() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20">
        <div className="d-flex-r">
          <div className="flex-1">购买数量</div>
          <CalcCount min={1} number={count} onChange={(value) => setCount(value)} max={99} />
        </div>
        <div className="font-size-12 text-color-9 mt-10">
          套餐有效期:{orderInfo?.startEffectTime ? dayjs(orderInfo.startEffectTime).format('YYYY-MM-DD') : '-'}至
          {orderInfo?.endEffectTime ? dayjs(orderInfo.endEffectTime).format('YYYY-MM-DD') : '-'}
          <span className="ml-10">
            共 <span className="text-color-red">{orderInfo?.packPeriodTotalNum}</span> 期
          </span>
        </div>
      </div>
    );
  }

  /**
   * 订单明细
   * @returns view
   */
  function renderOrderInfo() {
    return (
      <div className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20">
        <div>订单明细</div>
        <div className="d-flex-r ai-center pl-20 mt-20">
          <div className="font-size-12">商品总价：</div>
          <div className="pl-20">￥{orderInfo?.salePrice}</div>
        </div>
        <div className="d-flex-r ai-center pl-20 mt-20">
          <div className="font-size-12">优惠金额：</div>
          <div className="pl-20">￥{orderInfo?.couponPrice}</div>
        </div>
        <div className="d-flex-r ai-center pl-20 mt-20">
          <div className="font-size-12">商品合计：</div>
          <div className="pl-20">￥{orderInfo?.realPrice}</div>
        </div>
      </div>
    );
  }
  const settings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // 自动滚动
    autoplaySpeed: 4000,
  };

  /**
   * 支付方式
   */
  function renderPayType() {
    return (
      <div
        ref={payTypeRef}
        className="mt-10 bg-white pt-10 pb-10 pl-20 pr-20"
        style={{
          border: '2px solid transparent',
          borderRadius: '4px',
          ...(selectPayType ? { animation: 'flashBorderPay 0.5s 3 forwards' } : {}),
        }}
      >
        <style>{`
          @keyframes flashBorderPay {
            0% { border-color: transparent; }
            50% { border-color: #f53f3f; }
            100% { border-color: transparent; }
          }
        `}</style>
        <div>请选择支付方式</div>
        {payConfigList.map((item, idx) => {
          let subLabel = item.payType === PayType.balance ? `(账户余额￥${balance})` : '';
          // 是否使用开关
          let useSwitch = false;
          // 本条支付是余额支付 可以组合支付 又没有首充续充
          if (item.payType === PayType.balance && orderInfo?.isUnion && !preMoneyList?.length) {
            // 有余额但不够支付 单选框变成开关
            if (balance > 0 && balance < orderInfo.realPrice) {
              useSwitch = true;
            } else if (
              balance > 0 &&
              selectEquity &&
              balance < orderInfo.realPrice + orderInfo.cardProductActivityEquityPackJson!.price
            ) {
              useSwitch = true;
            }
          }
          return (
            <>
              <div
                key={idx}
                className="pl-20 mt-20 d-flex-r ai-center"
                onClick={() => {
                  if (useSwitch) {
                    setIsUnion(!isUnion);
                  } else {
                    setPayType(item.payType!);
                  }
                  if (!!preMoneyList.length && item.payType !== PayType.balance && selectEquity) {
                    let _preMoney = getRealPayItem();
                    console.log('更换支付方式：', _preMoney);
                    setPreMoney(_preMoney);
                  }
                }}
              >
                <div className="flex-1 d-flex-r ai-center jc-between">
                  <div className="d-flex-r ai-center">
                    <img className="icon-20 mr-10" src={`/pic/${PayType.typeIcon(item.payType)}`} alt="" />
                    <span className="font-size-12">{item.name || PayType.typeStr(item.payType)}</span>
                    <span
                      className={`ml-10 font-size-12 text-color-${item.payType === PayType.balance ? '9' : 'red'}`}
                      onClick={(e) => {
                        if (item.payType === PayType.balance) {
                          navigate('/recharge');
                        }
                      }}
                    >
                      {subLabel}
                    </span>
                    {useSwitch && (
                      <span className="font-size-12 text-color-9 mr-2">
                        {isUnion ? `支付¥${balance}` : '需组合支付'}
                      </span>
                    )}
                    {isUnion && item.payType === payType && (
                      <span className="font-size-12 text-color-9 mr-2">
                        支付¥
                        {formatNumber(
                          (orderInfo?.realPrice ?? 0) +
                            (selectEquity ? orderInfo?.cardProductActivityEquityPackJson?.price ?? 0 : 0) -
                            balance
                        )}
                      </span>
                    )}
                  </div>
                  {useSwitch ? (
                    <Switch
                      uncheckedIcon={false}
                      checkedIcon={false}
                      onColor="#6571ff"
                      offColor="#ccc"
                      width={40}
                      height={24}
                      checked={isUnion}
                      onChange={() => setIsUnion(!isUnion)}
                    />
                  ) : (
                    <RadioBox
                      value={item.payType === payType}
                      // disabled={item.payType === PayType.balance && !canBalancePay && !isUnion}
                    />
                  )}
                </div>
                <div className="w-50"></div>
              </div>
              {preMoneyList?.length <= 0 && !!rechargePackageList.length && item.payType === PayType.balance && (
                <div className="mt-10">
                  <Slider
                    {...settings}
                    infinite={rechargePackageList.length <= 1 ? false : true}
                    className="bw-100 custom-swiper"
                  >
                    {rechargePackageList?.map((item: any) => {
                      return (
                        <div className="d-flex ai-center jc-start bw-100 h-80 p-10 mt-10">
                          {item.map((children: any) => {
                            // 到账金额
                            let getAmount = Number(children.price ?? 0) + Number(children.activityAmount ?? 0);
                            // 赠送金额
                            let giveAmount =
                              Number(children.price ?? 0) >= Number(children.amount ?? 0)
                                ? Number(children.activityAmount ?? 0) +
                                  Number(children.price ?? 0) -
                                  Number(children.amount ?? 0)
                                : 0;
                            // 充值金额
                            let rechargeAmount = Number(children.amount ?? 0);
                            return (
                              <div
                                className={`d-flex-c ai-center jc-center w-110 mb-20 h-70 mr-10 bg-gray pos-r border border-radius-8`}
                                key={children.payDetailId}
                                onClick={() => navigate(`/recharge?id=${children?.payDetailId}`)}
                              >
                                {/* 充 amount 得 price */}
                                <div className=" text-color-origin-red">
                                  <span>到账</span>
                                  <span className="font-size-18">{formatNumber(getAmount)}</span>元
                                </div>
                                {getAmount > 0 && (
                                  <div className="font-size-12 mt-3">赠送{formatNumber(giveAmount)}</div>
                                )}
                                <div className="mt-3">售价:{formatNumber(rechargeAmount)}元</div>
                                {modelParsePrice(children?.price ?? 0) > modelParsePrice(children?.amount ?? 0) && (
                                  <img src="/pic/icon_preferential.png" className="icon-26 pos-a r-0 t-0" alt="" />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              )}
            </>
          );
        })}
      </div>
    );
  }
  /**
   * 权益包+套餐金额
   *  - 小于强冲数据中的支付金额 → 展示【最低强冲金额】
   *  - 大于等于强冲金额 → 展示【套餐+权益包金额】
   */
  const getRealPayAmount = () => {
    // 权益包+套餐金额
    let payAmount = Number(orderInfo!.cardProductActivityEquityPackJson!.price) + Number(orderInfo?.orderPrice || 0);

    // 强冲数据（提取金额 + 排序）
    let sortedPreMoney = preMoneyList
      .map((item) => Number(item.payAmount))
      .filter(Boolean)
      .sort((a, b) => a - b);

    // 找到 >= 总金额的最小档位
    let targetPreMoney = sortedPreMoney.find((item) => item >= payAmount);

    // 最终显示金额 可以手动选择充值金额
    return preMoney ? preMoney.payAmount : targetPreMoney ?? payAmount;
  };

  let price = (payType === PayType.balance ? orderInfo?.realPrice : preMoney?.payAmount ?? orderInfo?.realPrice) ?? 0;

  if (selectEquity) {
    let _price = (price = price + orderInfo!.cardProductActivityEquityPackJson!.price);
    if (!!preMoneyList.length && payType !== PayType.balance) {
      price = getRealPayAmount();
    } else {
      price = _price;
    }
  }
  if (isUnion) {
    price -= balance;
  }
  return (
    <Page
      className="d-flex-c bg-gray"
      contentClassName="flex-1 h-1 d-flex-c"
      appBar={<AppBar title="支付订单" onBack={handleBack}></AppBar>}
    >
      <div className="flex-1 overflow-y">
        {renderSelectPack()}
        {renderCount()}
        {renderOrderInfo()}
        {renderPayType()}
        <OrderAgreement onAgreeChange={(v) => setAgreementAgreed(v)} />
      </div>
      <div className="pt-10 pb-10 pl-20 pr-20 bg-white">
        <Button
          type={!agreementAgreed ? 'gray' : 'primary'}
          size="md"
          disabled={main?.ispreview}
          long
          onClick={() => {
            if (!agreementAgreed) {
              showToast('请勾选订购须知后，可订购~');
              return;
            }
            handlePay();
          }}
        >
          确认支付￥{formatNumber(price)}
          {!!selectEquity && <span className="font-size-12 ml-5 text-color-origin">(含权益费)</span>}
        </Button>
      </div>
    </Page>
  );
}
